import { Vue } from 'vue-property-decorator';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import api from '@/api/registration';
import { RegistrationSetup } from '@/interfaces/registration/RegistrationSetup';
import { RegistrationData } from '@/interfaces/registration/RegistrationData';
import { RegistrationError } from '@/interfaces/registration/RegistrationError';
import { RegistrationModel } from '@/interfaces/registration/models/RegistrationModel';
import { QuestionsModel } from '@/interfaces/registration/models/QuestionsModel';
@Module({ namespaced: true })

class Registration extends VuexModule {
  public registrationSetup!: RegistrationSetup;
  public registrationData!: RegistrationData;
  public registrationModel: RegistrationModel = {};
  public registrationErrors: Array<RegistrationError> = [];
  public fetchedData = false;

  @Mutation
  public updateRegistrationSetup (data: RegistrationSetup): void {
    this.registrationSetup = data;
  }

  @Mutation
  public saveRegistrationData (data: RegistrationData): void {
    this.registrationData = data;

    if (data.user) {
      this.registrationModel.login = {
        id: data.user.id,
        guid: data.user.guid,
        email: data.user.email,
        agreeToTerms: true
      };

      this.registrationModel.personalInfo = {
        email: data.user.email,
        firstName: data.user.firstName,
        lastName: data.user.lastName,
        phone: data.user.phone,
        birthDate: data.user.birthDate,
        gender: data.user.gender,
        userBio: data.user.bio,
        twitterHandle: data.user.twitter,
        instagramHandle: data.user.instagram,
        pictureURL: data.user.pictureURL
      };
    } else {
      this.registrationModel.login = {};
      this.registrationModel.personalInfo = {};
    }

    if (data.inivite != null && (data.registrationType === 'OrganizationAdminInvite' || data.registrationType === 'OrganizationSeatInvite') && data.inivite.organization != null) {
      this.registrationModel.personalInfo.organizationId = data.inivite.organization?.id;
      this.registrationModel.personalInfo.organizationName = data.inivite.organization?.name;
    }

    if (data.tagSets != null && data.tagSets.length > 0) {
      this.registrationModel.interests = {
        tagSetModels: data.tagSets.map((tagSet) => {
          const name = 'TagSet_' + tagSet.id;
          const selectedTags = data.selectedTags != null
            ? data.selectedTags.filter((tagId) => {
              return tagSet.parentTags.findIndex((parentTag) => {
                return parentTag.id === tagId || parentTag.subTags.findIndex((subTag) => {
                  return subTag.id === tagId;
                }) !== -1;
              }) !== -1;
            })
            : [];

          return { name: name, tags: selectedTags };
        })
      };
    }

    this.registrationModel.education = {
      educationItems: data.educationItems
    };

    this.registrationModel.workHistory = {
      workHistoryItems: data.workHistoryItems
    };

    if (data.answers != null) {
      const questions: QuestionsModel = {};
      const eventQuestions: QuestionsModel = {};
      const volunteerQuestions: QuestionsModel = {};
      data.answers.forEach((answer) => {
        if (data.questions.findIndex((question) => { return question.id === answer.formQuestionID; }) !== -1) {
          questions[answer.formQuestionID as number] = { id: answer.formQuestionID, value: answer.value };
        }

        if (data.eventQuestions.findIndex((question) => { return question.id === answer.formQuestionID; }) !== -1) {
          eventQuestions[answer.formQuestionID as number] = { id: answer.formQuestionID, value: answer.value };
        }

        if (data.volunteerQuestions.findIndex((question) => { return question.id === answer.formQuestionID; }) !== -1) {
          volunteerQuestions[answer.formQuestionID as number] = { id: answer.formQuestionID, value: answer.value };
        }
      });

      this.registrationModel.questions = questions;
      this.registrationModel.eventQuestions = eventQuestions;
      this.registrationModel.volunteerQuestions = volunteerQuestions;
    }

    this.registrationModel.eventMeals = data.eventMeals;
  }

  @Action
  public saveRegistrationSetup (data: RegistrationSetup): void {
    this.context.commit('updateRegistrationSetup', data);
  }

  @Action
  public loadRegistrationData (): Promise<boolean> {
    // debugger;
    if (this.fetchedData) {
      return Promise.resolve(true);
    } else {
      const url = '/account/register/registrationdata';
      const params = this.registrationSetup;

      return api
        .get(url, { params: params })
        .then(response => {
          if (response.data.redirectUrl !== undefined && response.data.redirectUrl !== '') {
            window.location.href = response.data.redirectUrl;
            return true;
          }

          this.context.commit('saveRegistrationData', response.data);
          return true;
        });
    }
  }

  @Mutation
  public updateRegistrationModel (payload: { data: any; model: string }): void {
    Vue.set(this.registrationModel, payload.model, payload.data);
  }

  @Action
  public saveRegistrationModel (payload: { data: any; model: string }): void {
    this.context.commit('updateRegistrationModel', payload);
  }

  @Mutation
  public updateRegistrationErrors (data: Array<RegistrationError>): void {
    this.registrationErrors = data;
  }

  @Action
  public saveRegistrationErrors (data: Array<RegistrationError>): void {
    this.context.commit('updateRegistrationErrors', data);
  }
}

export default Registration;
